import { apiEndpoints } from '../constants/apiEndpoints';
import Service from './service';

const GetJourneys = async () => {
  try {
    const res = await Service.get(apiEndpoints.GET_JOURNEYS);
    return res;
  } catch (error) {
    return error;
  }
};
export default GetJourneys;
